module.exports = __webpack_public_path__ + "img/member-0.a7c012e4.png";